
import styled from 'styled-components'
import Text from '../Text/Text';
import Row from '../Row/Row';
import SimpleButton from '../Buttons/SimpleButton';
import {Modal} from "../Modal/Modal";
import React from 'react';

interface ExitModalProps {
    theme: string;
    show: boolean;
    showModalToggle: any;
    exitModalText: string;
    exitCallback: () => void;
}
const ExitModalContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
min-width: 30%;
height: 30vh;
background: #000D30;
border-radius: 20px;
border: 1px solid #ffffff90;
`;

const ExitModal = React.forwardRef<
  HTMLDivElement,
  ExitModalProps
>(({ theme, show, showModalToggle, exitModalText, exitCallback }, ref) => {

  const onCloseClick = () => {
    showModalToggle(false);
  };

  const onYesClick = () => {
    exitCallback()
  }
  return (
    <Modal ref={ref} show={show} >
      <ExitModalContainer>
      <Text style={{padding: "10%"}}>
        {exitModalText}
      </Text>
      <Row gap="5rem">
      <SimpleButton onClick={onYesClick}>Yes</SimpleButton>
      <SimpleButton onClick={onCloseClick}>No</SimpleButton>
      </Row>
      </ExitModalContainer>


    </Modal>

  );
});

export default ExitModal;